import { Form, InputNumber } from 'antd';
import React from 'react';
import { ICreditLimitList } from '../type/CreditLimit.interface';

interface TargetEditableCellCellProps extends React.HTMLAttributes<HTMLElement> {
  editing: boolean;
  dataIndex: string;
  title: any;
  inputType: 'client_credit_limit';
  record: ICreditLimitList;
  index: number;
}

export const TargetEditableCell: React.FC<React.PropsWithChildren<TargetEditableCellCellProps>> = ({
  editing,
  dataIndex,
  title,
  inputType,
  record,
  index,
  children,
  ...restProps
}) => {
  let inputNode;

  if (inputType === 'client_credit_limit') {
    inputNode = <InputNumber placeholder='Set new credit limit' style={{ width: '100%' }} />;
  }

  return (
    <td {...restProps}>
      {editing ? (
        <Form.Item
          name={dataIndex}
          style={{ margin: 0 }}
          rules={[
            {
              required: true,
              message: `Please Input ${title}!`,
            },
          ]}
        >
          {inputNode}
        </Form.Item>
      ) : (
        children
      )}
    </td>
  );
};
